import { useContext } from 'react';
import { useQuery } from 'react-query';
import { getBulkImportHistory } from 'services';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

const IMPORT_HISTORY_QUERY_KEY = 'importHistory';

export const useGetDataImportHistory = () => {
  const { corpAcctNbr } = useContext(FeatureContext);

  return useQuery(
    [IMPORT_HISTORY_QUERY_KEY],
    () => getBulkImportHistory(corpAcctNbr),
    {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchInterval: 10000,
      refetchIntervalInBackground: false,
    },
  );
};
